import styled from 'styled-components';

interface CheckboxProps {
    text: string;
    active: boolean;
    onClick: () => void;
}

const Box = styled.div`
  height: 20px;
  width: 20px;
  background: ${(props: {active: boolean}) => props.active ? "#4affb5" : "transparent"};
  border: 1px solid ${props => props.active ? "transparent" : "#EEEEEE"};
  border-radius: 6px;
  margin-right: .5rem;
  transition: .1s;
`;

const CheckboxStyle = styled.div`
  display: flex;
  align-items: center;
  border-radius: 12px;
  border: 1px solid  ${(props: {active: boolean}) => props.active ? "transparent" : "#EEEEEE"};
  background: ${props => props.active ? "#f2fff8" : "transparent"};
  padding: .5rem;
  cursor: pointer;
  transition: .1s;

  &:hover {
    border-color: ${props => props.active ? "transparent" : "#c8c8c8"};

    ${Box} {
      border-color: ${props => props.active ? "transparent" : "#c8c8c8"};
    }
  }
`;

export default function Checkbox(props: CheckboxProps) {

    return <CheckboxStyle active={props.active} onClick={props.onClick}>
        <Box active={props.active}>

        </Box>
        <div>
            {props.text}
        </div>
    </CheckboxStyle>
}